import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DateAdapter } from '@uplift/services';


export const GlobalLocalizationProvider: React.FC = (props) => (
  <LocalizationProvider dateAdapter={DateAdapter} {...props} />
);
